import { Box } from '@rsos/base-components';
import type { Checkbox } from '../../../constants/ShareEvent.types';
import { ShareStyledCheckbox } from './index.styles';

interface ShareEventCheckboxProps {
  checkbox: Checkbox;
  onChange: () => void;
}

const ShareEventCheckbox = ({
  checkbox,
  onChange,
}: ShareEventCheckboxProps) => {
  const IconComponent = checkbox.icon ? (
    <checkbox.icon height={12} width={12} color="primaryText" />
  ) : null;

  return (
    <Box
      borderRadius="5px"
      border="1px solid"
      borderColor={checkbox.isChecked ? 'primaryBase' : 'lightLineDivider'}
      mb="8px"
      backgroundColor={checkbox.isChecked ? 'highlights' : 'background'}
      data-name={checkbox.id}
    >
      <ShareStyledCheckbox
        label={checkbox.label}
        description={checkbox.description}
        isChecked={checkbox.isChecked}
        onChange={onChange}
        disabled={checkbox.disabled}
        checkboxID={checkbox.id}
        labelIcon={IconComponent}
      />
    </Box>
  );
};

export default ShareEventCheckbox;
